/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.20",
    versionName: "0.2.0-nightly.2026.2.20",
    versionChannel: "nightly",
    buildDate: "2026-02-20T00:13:03.003Z",
    commitHash: "60e791c6e91b8c99f7ebbb4d7a01727c2ec3d344",
};
